/* -----------------------------
    PARSERS
--------------------------------*/
export const allUpperCase = value => (value ? value.toUpperCase() : undefined);

export const nationalStockNumber = value => {
  if (value) {
    let displayValue = '';
    const valueWithoutDashes = value.replace(/-/g, '');
    for (let idx = 0; idx < valueWithoutDashes.length; idx += 1) {
      if (idx === 4) {
        displayValue += '-';
      } else if (idx === 6) {
        displayValue += '-';
      } else if (idx === 9) {
        displayValue += '-';
      }
      displayValue += valueWithoutDashes[idx];
    }
    return displayValue;
  }
  return undefined;
};

/* -----------------------------
    COMPOSE PARSERS
--------------------------------*/
export const composeParsers = (...parsers) => value =>
  parsers.reduce((error, parser) => error || parser(value), undefined);



// WEBPACK FOOTER //
// ./src/utils/parseUtils.js